import React, { Fragment, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import cx from 'classnames'

// Layout
import AppHeader from '../Layout/AppHeader'
import AppSidebar from '../Layout/AppSidebar'
import AppFooter from '../Layout/AppFooter'
import ThemeOptions from '../Layout/ThemeOptions'

import { userTimeout } from '../Redux/Reducers/user'
import { checkThemePermission, renderBlockColorClass, renderBlockStyle } from '../helper'
import CMSModal from '../CMSComponent/CMSModal'
import OpenModal from '../CMSComponent/Forms/Fields/openModal'

const select = (state) => ({
  user: state.User.user,
  themeOptions: state.ThemeOptions,
  editModal: state.CMS.editModal,
  modelDala: state.CMS.modelDala,
})

const Wrapper = ({ user, children, themeOptions, newNav }) => {
  const dispatch = useDispatch()
  const updateApiData = useSelector((state) => state.CMS?.updateApiData)

  window.onunload = () => {
    dispatch(userTimeout())
  }

  useEffect(() => {
    if (themeOptions.updatedAt === null) {
      // dispatch(reduxLoad())
    }
  }, [user])

  return (
    <Fragment>
      {(checkThemePermission('edit_theme') || checkThemePermission('Edit_theme')) && <ThemeOptions />}
      <AppHeader canEditCms={true} newNav={newNav} updateApiData={updateApiData} />
      {updateApiData?.show_banner && (
        <div className='bg-danger subtitle2 text-light text-center px-5 py-1' style={{ width: '100vw', position: 'fixed', top: '3.8rem', zIndex: 9 }}>
          Test
        </div>
      )}

      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className={cx('app-main__inner', renderBlockColorClass(themeOptions.bodyColor))} style={renderBlockStyle(themeOptions.bodyColor)}>
            <div style={{ marginTop: updateApiData?.show_banner && '1rem' }}>{children}</div>
          </div>
          <AppFooter />
        </div>
      </div>
      <CMSModal />
      <OpenModal />
    </Fragment>
  )
}

export default connect(select)(Wrapper)
